import useLocalStorage from "~/hooks/useLocalStorage";
const alwaysHideOnboardingQuestionnaireKey = "OctopusAlwaysHideOnboardingQuestionnaire";
export { alwaysHideOnboardingQuestionnaireKey };
export function useAlwaysHideOnboardingQuestionnaire() {
    return useLocalStorage<boolean>(alwaysHideOnboardingQuestionnaireKey, false);
}
